import React from "react";
import { RatingOverviewContext } from "../../context/ratingOverviewContext";
import IRatingOverviewSearch from "../../interface/iRatingOverviewSearch";
import InputDate from "../../../../components/inputs/date/inputDate";

const SearchToDate = (): React.JSX.Element => {
  const {
    ratingOverviewSearch,
    setRatingOverviewSearch,
  }: {
    ratingOverviewSearch: IRatingOverviewSearch;
    setRatingOverviewSearch: React.Dispatch<
      React.SetStateAction<IRatingOverviewSearch>
    >;
  } = React.useContext(RatingOverviewContext);

  const handleChange = (date: any): void =>
    setRatingOverviewSearch((prevState: any) => ({
      ...prevState,
      toDate: date,
    }));

  return (
    <InputDate
      disabled={false}
      label="Ende"
      error
      required
      date={ratingOverviewSearch.toDate}
      setDate={handleChange}
    />
  );
};

export default SearchToDate;
